export function createScrollContainer(): HTMLDivElement {
    const scrollContainer = document.createElement('div');
    const scrollHand = document.createElement('div');
    const scroll = document.createElement('div');

    scrollContainer.id = 'scroll-container';
    scrollHand.className = 'scroll-hand';
    scroll.className = 'scroll';

    scrollContainer.appendChild(scroll);
    scrollContainer.appendChild(scrollHand);

    return scrollContainer;
}

export const SHOWN_SCROLL_CONTAINER_STYLE_CLASS = 'shown-scroll-container';
